// Header.js
import React from 'react';
import { BrowserRouter as Router, Route, Link, Routes } from 'react-router-dom';
import logo from '../Images/surfermonkeylogo.png'
import '../Styles/Header.css';

const Header = ({ children }) => {
    const devDocsUrl = 'https://playground.surfermonkey.io/dev/';
    return (
        <div className="sticky-navbar">
            <div className="logo-container">
                <div className="logo">
                    <a href="https://www.surfermonkey.io/" target="_blank" rel="noreferrer">
                        <img src={logo} alt="SurferMonkey Logo" />
                    </a>
                </div>
                <div className="menu">
                    <Link to="/">Home</Link>
                    <Link to="/regulatory-dashboard">Regulators</Link>
                    <Link to="/FAQs">FAQs</Link>
                    <a href={devDocsUrl} target="_blank" rel="noreferrer">Dev Docs</a>

                </div>
            </div>
            <div className="children-container">
                {children}
            </div>
        </div>
    );
};

export default Header;